import './Skeleton.css';

export interface SkeletonProps {
  /** Number of skeleton lines/blocks. */
  count?: number;
  height?: number;
  /** 'text' renders stacked lines; 'block' renders a single rectangle. */
  variant?: 'text' | 'block';
}

/** Generic loading placeholder (DEVELOPMENT_PLAN §17.1). */
export function Skeleton({ count = 3, height = 16, variant = 'text' }: SkeletonProps) {
  if (variant === 'block') {
    return <div className="skeleton" style={{ height, borderRadius: 'var(--radius-md)' }} data-testid="skeleton" />;
  }
  return (
    <div className="stack" data-testid="skeleton">
      {Array.from({ length: Math.max(1, count) }, (_, i) => (
        <div key={i} className="skeleton" style={{ height, width: i === count - 1 ? '60%' : '100%' }} />
      ))}
    </div>
  );
}
